import makeStyles from '@material-ui/core/styles/makeStyles';

const TAB_HEADER_HEIGHT = 48;

const useStyles = makeStyles((theme) => ({
  paper: {
    minWidth: 340,
    [theme.breakpoints.down(theme.breakpoints.values.tablet)]: {
      height: '80%',
      minWidth: 'unset',
    },
  },
  container: {
    width: '100%',
    height: '100vh',
    backgroundColor: theme.palette.colors.backdropColor,
    [theme.breakpoints.down(theme.breakpoints.values.tablet)]: {
      height: '100%',
    },
  },
  tabHeader: {
    borderBottom: 1,
    borderColor: 'divider',
    color: theme.palette.colors.backdropOnColor,
  },
  tabs: {
    pointerEvents: 'none', // Only 1 tab available for now
    height: TAB_HEADER_HEIGHT,
  },
  tabPanel: {
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    position: 'relative',
    maxHeight: `calc(100% - ${TAB_HEADER_HEIGHT}px)`,
  },
  navItem: {
    flexDirection: 'column',
    alignItems: 'start',
  },
  itemColor: {
    width: 18,
    height: 18,
    borderRadius: 4,
    marginRight: 6,
    display: 'inline-block',
    boxShadow: 'inset 0 0 0 1px rgb(0 0 0 / 4%)',
  },
  navItemTitle: {
    fontSize: 16,
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.colors.backdropOnColor,
  },
  navItemSubTitle: {
    fontSize: 14,
    color: theme.palette.colors.surfaceOnColor,
  },
  emptyMessageTitle: {
    fontSize: 16,
    marginBottom: 4,
    color: theme.palette.colors.backdropOnColor,
  },
  emptyMessageSubtitle: {
    fontSize: 14,
    color: theme.palette.colors.backdropOnColor,
  },
}));

export default useStyles;
